module.exports = __webpack_public_path__ + "static/media/calendar.604675bd.svg";